<template>
    <div v-if="boxshow" class="boxshow"> <!-- background -->
        <div id="popup-messagebox"> <!--window -->
            <div :class="'message ' + icon_class" v-html="message_html"></div>
            <div v-if="message2" v-html="message2_html" class="message2">

            </div>
            <div v-for="(button, index) in buttons">
                <a v-on:click="okButton(button.action, button.url)" :class="button.class" >
                    <i v-if="button.is_icon" :class="button.icon"></i>
                    {{ button.msg }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    //v-if="boxshow"
    import EventBus from './event-bus';
    export default {
        name: "msgbox-component",
        data: function(){
            return {
                boxshow: false,
                type: '',       // error, warn, info, close
                message : null,
                message2 : null,
                buttons: [],    //連想配列がはいる。action=ok,link  msg=ボタン名, icon=iconのcssクラス, class=ボタンのcss, url=actionがlinkの場合に利用
                icon_class: '',
                message_html: '',
                message2_html: '',
                default_button_title: 'OK',
            }
        },
        created: function() {
            EventBus.$on('msgbox', function (type, message, buttons, message2=null) {

                if (this.type == 'close'){
                    this.boxshow = false;
                    return;
                }

                this.boxshow = true;
                this.type = type;
                this.message = message;
                this.message2 = message2;
                this.buttons = buttons;


                switch (this.type) {
                    case 'error': this.icon_class = 'attention'; break;
                    case 'warn': this.icon_class = 'warning'; break;
                    case 'info': this.icon_class = 'info'; break;
                }

                this.message_html = '';
                if (Array.isArray(this.message)) {
                    this.message.forEach(function(val){
                        this.message_html += val + "<br/>";
                    }.bind(this));
                } else {
                    this.message_html = this.message;
                }

                this.message2_html = '';
                if (Array.isArray(this.message2)) {
                    this.message2.forEach(function(val){
                        this.message2_html += val + "<br/>";
                    }.bind(this));
                } else {
                    this.message2_html = this.message2;
                }

                buttons.forEach(function(val,index,ar){
                    if (!ar[index].msg) {
                        ar[index].msg = this.default_button_title;
                    }
                    if (ar[index].icon){
                        ar[index].is_icon = true;
                    } else {
                        ar[index].is_icon = false;
                    }
                    if (!ar[index].url){
                        ar[index].url = '';
                    }
                    if (!ar[index].class){
                        ar[index].class = 'btnTypeLink1'
                    }
                }.bind(this))
                console.log(buttons);

            }.bind(this));
        },
        beforeDestroy: function() {
            // EventBus イベントのアンバインド
            EventBus.$off('msgbox');
        },
        methods: {
            okButton: function(action, url) {
                this.boxshow = false;
                switch (action){
                    case 'ok':
                        break;
                    case 'link':
                        location.href = url;
                        break;
                    // case 'reload': location.reload();break;
                    // case 'replace':
                    //     location.replace(this.url);break;
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/mk-msgbox-component.vue